<div class="company-status-container">
  
  <!-- Loading Spinner -->
  <div class="loading-overlay" *ngIf="isLoading">
    <div class="spinner-container">
      <div class="spinner-circle"></div>
      <p class="loading-text">Processing...</p>
    </div>
  </div>

  <!-- Success/Toast Message -->
  <div class="toast-notification" *ngIf="showSuccessMessage">
    <span class="material-icons toast-icon">check_circle</span>
    <span class="toast-text">{{ successMessageText }}</span>
  </div>

  <!-- Header Section -->
  <div class="header-section">
    <div class="title-area">
      <h1 class="main-title">Company Profile</h1>
      <p class="subtitle">Manage your company details and track your registration status.</p>
    </div>
    
    <!-- Status badge on the header -->
    <!-- <div class="header-status-badge" [ngClass]="status">
      <span class="badge-dot"></span>
      <span class="badge-text">{{ status === 'clarification' ? 'Clarification Required' : status }}</span>
    </div> -->
    <!--signout top right corner-->
  <div class="bottom-logout-container" >
    <button class="btn-logout" (click)="logout()">
      <span class="material-icons">logout</span>
      Sign Out
    </button>
  </div>
  </div>

  <ng-container *ngIf="hasLoadedProfile">
  <!-- Status Cards Wrapper -->
  <div class="status-wrapper" [ngSwitch]="status">
    
    <!-- PENDING APPROVAL -->
    <div class="status-card pending animate-fade-in" *ngSwitchCase="'pending'">
      <div class="status-left">
        <div class="icon-circle">
          <span class="material-icons">schedule</span>
        </div>
        <div class="status-text-content">
          <span class="status-badge">
            <span class="badge-dot"></span> PENDING APPROVAL
          </span>
          <h2 class="status-title">Registration Under Review</h2>
          <p class="status-desc">
            Your company registration is currently under review by our team. You will be notified via email once the review is complete.
          </p>
        </div>
      </div>
      <div class="status-right">
        <!--<button class="btn-support" (click)="contactSupport()">
          <span class="material-icons">language</span>
          Contact Support
        </button>-->
      </div>
    </div>

    <!-- APPROVED -->
    <div class="status-card approved animate-fade-in" *ngSwitchCase="'approved'">
      <div class="status-left">
        <div class="icon-circle">
          <span class="material-icons">check_circle</span>
        </div>
        <div class="status-text-content">
          <span class="status-badge">
            <span class="badge-dot"></span> APPROVED
          </span>
          <h2 class="status-title">Company Verified</h2>
          <p class="status-desc">
            Your company registration has been approved. You now have full access to the BeExpert dashboard and can start creating jobs, assessments, and AI interviews.
          </p>
        </div>
      </div>
      <div class="status-right">
        <button class="btn-go-dashboard" (click)="goToDashboard()">
          Go to Dashboard
          <span class="material-icons">arrow_forward</span>
        </button>
      </div>
    </div>

    <!-- REJECTED -->
    <div class="status-card rejected animate-fade-in" *ngSwitchCase="'rejected'">
      <div class="status-content-wrapper">
        <div class="status-row">
          <div class="status-left">
            <div class="icon-circle">
              <span class="material-icons">cancel</span>
            </div>
            <div class="status-text-content">
              <span class="status-badge">
                <span class="badge-dot"></span> REJECTED
              </span>
              <h2 class="status-title">Registration Not Approved</h2>
              <p class="status-desc">
                Your company registration could not be approved. Please review the rejection reason below, update the required information, and resubmit your application for review.
              </p>
            </div>
          </div>
          <div class="status-right" *ngIf="!isEditing">
            <button class="btn-edit-resubmit" (click)="enableEditing()">
              <span class="material-icons">edit</span>
              Edit & Resubmit
            </button>
          </div>
        </div>
        
        <!-- Rejection Reason Card -->
        <div class="reason-container">
          <h4 class="reason-label">REJECTION REASON</h4>
          <div class="reason-text-box">
            <p>{{ rejectionReason }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- NEED CLARIFICATION -->
    <div class="status-card clarification animate-fade-in" *ngSwitchCase="'clarification'">
      <div class="status-content-wrapper">
        <div class="status-row">
          <div class="status-left">
            <div class="icon-circle">
              <span class="material-icons">forum</span>
            </div>
            <div class="status-text-content">
              <span class="status-badge">
                <span class="badge-dot"></span> REQUEST CLARIFICATION
              </span>
              <h2 class="status-title">Request Clarification</h2>
              <p class="status-desc">
                Your company registration needs clarification. Please review the clarification request below, update the required information, and resubmit your application for review.
              </p>
            </div>
          </div>
          <div class="status-right" *ngIf="!isEditing">
            <button class="btn-edit-resubmit" (click)="enableEditing()">
              <span class="material-icons">edit</span>
              Edit & Resubmit
            </button>
          </div>
        </div>
        
        <!-- Clarification Request Card -->
        <div class="reason-container">
          <h4 class="reason-label">CLARIFICATION REQUEST *</h4>
          <div class="reason-text-box">
            <p>{{ clarificationRequest }}</p>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- Form Wrapper to organize sections -->
  <div class="profile-form-layout">
    
    <!-- Left column: Logo Card & Mode Info -->
    <div class="form-aside">
      
      <!-- Company Logo Card -->
      <div class="form-card logo-card" [class.edit-mode]="isEditing">
        <h3 class="card-section-title">Company Logo</h3>
        
        <div class="logo-upload-container" [class.clickable]="isEditing" (click)="isEditing && logoInput.click()">
          <input 
            #logoInput 
            type="file" 
            accept=".png,.jpg,.jpeg,.svg" 
            hidden 
            (change)="onLogoSelect($event)"
          />

          <!-- If Logo exists -->
          <div class="logo-display-wrapper" *ngIf="companyDetails.logo_url">
            <img [src]="companyDetails.logo_url" alt="Company Logo" class="logo-img" />
            <button 
              type="button" 
              class="remove-logo-overlay" 
              *ngIf="isEditing" 
              (click)="removeLogo($event)"
              title="Remove Logo"
            >
              <span class="material-icons">close</span>
            </button>
          </div>

          <!-- If No Logo exists -->
          <div class="logo-placeholder-wrapper" *ngIf="!companyDetails.logo_url">
            <div class="placeholder-circle">
              <span class="material-icons">business</span>
            </div>
            <p class="logo-help-text" *ngIf="isEditing">Click to upload logo</p>
            <p class="logo-help-text" *ngIf="!isEditing">No logo uploaded</p>
          </div>
        </div>
        <p class="logo-spec-text" *ngIf="isEditing">PNG, JPG or SVG up to 2MB</p>
      </div>

      <!-- Mode & Quick Action Badge -->
      <div class="info-aside-card">
        <div class="mode-status-line">
          <span class="status-dot" [class.editing]="isEditing"></span>
          <span class="mode-text">{{ isEditing ? 'Editing Mode Active' : 'Viewing Profile' }}</span>
        </div>
        <p class="mode-desc">
          {{ isEditing ? 'You can update your Logo, LinkedIn, About Company, Office Locations, and HR Contact Details.' : 'Profile fields are locked. Click edit to update details.' }}
        </p>
        
        <button 
          class="btn-aside-edit" 
          *ngIf="status === 'approved' && !isEditing" 
          (click)="enableEditing()"
        >
          <span class="material-icons">edit</span>
          Edit Profile
        </button>
      </div>

    </div>

    <!-- Right column: Company Details Form Fields -->
    <div class="form-main-content">
      
      <!-- Card Section: Company General details -->
      <div class="form-card details-card" [class.edit-mode]="isEditing">
        <h3 class="card-section-title">Company Details</h3>
        
        <div class="form-grid">
          
          <!-- Company Name (LOCKED) -->
          <div class="form-group">
            <label class="form-label">
              Company Name 
              <span class="required-star">*</span>
              <span class="lock-indicator" title="Locked field from signup">
                <span class="material-icons">lock</span>
              </span>
            </label>
            <div class="input-wrapper locked">
              <input 
                type="text" 
                class="form-input" 
                [(ngModel)]="companyDetails.company_name" 
                readonly
              />
              <span class="help-text">From signup</span>
            </div>
          </div>

          <!-- Industry (LOCKED) -->
          <div class="form-group">
            <label class="form-label">
              Industry 
              <span class="required-star">*</span>
              <span class="lock-indicator" title="Locked field from signup">
                <span class="material-icons">lock</span>
              </span>
            </label>
            <div class="input-wrapper locked">
              <input 
                type="text" 
                class="form-input" 
                [(ngModel)]="companyDetails.industry" 
                readonly
              />
              <span class="help-text">From signup</span>
            </div>
          </div>

          <!-- Company URL (LOCKED) -->
          <div class="form-group">
            <label class="form-label">
              Company URL 
              <span class="required-star">*</span>
              <span class="lock-indicator" title="Locked field from signup">
                <span class="material-icons">lock</span>
              </span>
            </label>
            <div class="input-wrapper locked">
              <input 
                type="text" 
                class="form-input" 
                [(ngModel)]="companyDetails.company_url" 
                readonly
              />
              <span class="help-text">From signup</span>
            </div>
          </div>

          <!-- LinkedIn Profile (EDITABLE) -->
          <div class="form-group">
            <label class="form-label">LinkedIn Profile</label>
            <input 
              type="text" 
              class="form-input" 
              placeholder="https://linkedin.com/company/... or https://linkedin.com/in/..."
              [(ngModel)]="companyDetails.linkedin_profile" 
              [readonly]="!isEditing"
              [class.editable]="isEditing"
              [class.input-error]="isEditing && isLinkedinInvalid()"
            />
            <span class="error-text" *ngIf="isEditing && isLinkedinInvalid()">
              Please enter a valid LinkedIn URL (e.g., https://linkedin.com/in/username or https://linkedin.com/company/companyname).
            </span>
          </div>

          <!-- About Company (EDITABLE) -->
          <div class="form-group full-width">
            <label class="form-label">About Company <span class="required-star">*</span></label>
            <textarea 
              class="form-textarea" 
              rows="4" 
              placeholder="Brief description of your company..."
              [(ngModel)]="companyDetails.about_company"
              [readonly]="!isEditing"
              [class.editable]="isEditing"
              [class.input-error]="isEditing && isAboutCompanyInvalid()"
            ></textarea>
            <span class="error-text" *ngIf="isEditing && isAboutCompanyInvalid()">
              About Company is required and must be between 10 and 2000 characters.
            </span>
          </div>

          <!-- Office Locations (EDITABLE Tag System) -->
          <div class="form-group full-width">
            <label class="form-label">Office Locations <span class="required-star">*</span></label>
            
            <!-- Adding System (Visible only in edit mode) -->
            <div class="location-add-wrapper" *ngIf="isEditing">
              <div class="autocomplete-container">
                <input 
                  type="text" 
                  class="form-input location-search-input" 
                  placeholder="e.g. Bengaluru, India"
                  [(ngModel)]="newLocationInput"
                  (keydown.enter)="addLocation(); $event.preventDefault()"
                  (input)="onLocationInput($event)"
                  (focus)="onLocationFocus($event)"
                  (blur)="onLocationBlur()"
                />
                <div class="suggestions-dropdown" *ngIf="showLocationsDropdown && filteredLocations.length">
                  <div 
                    class="suggestion-item" 
                    *ngFor="let loc of filteredLocations"
                    (mousedown)="selectLocation(loc)"
                  >
                    {{ loc }}
                  </div>
                </div>
              </div>
              <button type="button" class="btn-add-location" (click)="addLocation()">
                <span class="material-icons">add</span>
                Add
              </button>
            </div>

            <!-- Chips Display -->
            <div class="location-chips-container" *ngIf="companyDetails.office_locations?.length">
              <span class="location-chip" *ngFor="let loc of companyDetails.office_locations; let idx = index">
                <span class="material-icons chip-icon">place</span>
                <span class="chip-label">{{ loc }}</span>
                <button 
                  type="button" 
                  class="remove-chip-btn" 
                  *ngIf="isEditing" 
                  (click)="removeLocation(idx)"
                >
                  <span class="material-icons">close</span>
                </button>
              </span>
            </div>
            
            <p class="no-locations-placeholder" *ngIf="!companyDetails.office_locations?.length">
              No locations added yet. At least one location is required.
            </p>
          </div>

        </div>
      </div>

      <!-- Card Section: Point of Contact -->
      <div class="form-card details-card" [class.edit-mode]="isEditing">
        <div class="section-header-row">
          <div class="section-header-title">
            <h3 class="card-section-title">Point of Contact</h3>
            <p class="card-section-subtitle">Auto-filled from signup — locked for verification</p>
          </div>
          <span class="material-icons header-icon">contact_page</span>
        </div>

        <div class="form-grid">
          
          <!-- POC Name (LOCKED) -->
          <div class="form-group">
            <label class="form-label">
              Name 
              <span class="required-star">*</span>
              <span class="lock-indicator">
                <span class="material-icons">lock</span>
              </span>
            </label>
            <div class="input-wrapper locked">
              <input 
                type="text" 
                class="form-input" 
                [(ngModel)]="companyDetails.contact.poc_name" 
                readonly
              />
              <span class="help-text">From signup</span>
            </div>
          </div>

          <!-- POC Email (LOCKED) -->
          <div class="form-group">
            <label class="form-label">
              Email 
              <span class="required-star">*</span>
              <span class="lock-indicator">
                <span class="material-icons">lock</span>
              </span>
            </label>
            <div class="input-wrapper locked">
              <input 
                type="email" 
                class="form-input" 
                [(ngModel)]="companyDetails.contact.poc_email" 
                readonly
              />
              <span class="help-text">From signup</span>
            </div>
          </div>

          <!-- POC Phone (LOCKED) -->
          <div class="form-group">
            <label class="form-label">
              Mobile Number 
              <span class="required-star">*</span>
              <span class="lock-indicator">
                <span class="material-icons">lock</span>
              </span>
            </label>
            <div class="input-wrapper locked">
              <input 
                type="text" 
                class="form-input" 
                [(ngModel)]="companyDetails.contact.poc_phone" 
                readonly
              />
              <span class="help-text">From signup</span>
            </div>
          </div>

          <!-- Official Email (LOCKED) -->
          <div class="form-group">
            <label class="form-label">
              Official Email 
              <span class="required-star">*</span>
              <span class="lock-indicator">
                <span class="material-icons">lock</span>
              </span>
            </label>
            <div class="input-wrapper locked">
              <input 
                type="email" 
                class="form-input" 
                [(ngModel)]="companyDetails.contact.official_email" 
                readonly
              />
              <span class="help-text">From signup</span>
            </div>
          </div>

        </div>
      </div>

      <!-- Card Section: HR Contact details -->
      <div class="form-card details-card" [class.edit-mode]="isEditing">
        <div class="section-header-row">
          <div class="section-header-title">
            <h3 class="card-section-title">HR Contact</h3>
            <p class="card-section-subtitle">Hiring manager / HR representative details</p>
          </div>
          <span class="material-icons header-icon">badge</span>
        </div>

        <div class="form-grid">
          
          <!-- HR Name (EDITABLE) -->
          <div class="form-group">
            <label class="form-label">HR Name</label>
            <input 
              type="text" 
              class="form-input" 
              placeholder="Full name"
              [(ngModel)]="companyDetails.contact.hr_name" 
              [readonly]="!isEditing"
              [class.editable]="isEditing"
              (input)="onHrNameInput()"
              [class.input-error]="isEditing && isHrNameInvalid()"
            />
            <span class="error-text" *ngIf="isEditing && isHrNameInvalid()">
              HR Name must contain only alphabets and spaces.
            </span>
          </div>

          <!-- HR Email (EDITABLE) -->
          <div class="form-group">
            <label class="form-label">HR Email</label>
            <input 
              type="email" 
              class="form-input" 
              placeholder="hr@company.com"
              [(ngModel)]="companyDetails.contact.hr_email" 
              [readonly]="!isEditing"
              [class.editable]="isEditing"
              [class.input-error]="isEditing && isHrEmailInvalid()"
            />
            <span class="error-text" *ngIf="isEditing && isHrEmailInvalid()">
              Please enter a valid HR Email address.
            </span>
          </div>

          <!-- HR Phone (EDITABLE) -->
          <div class="form-group full-width">
            <label class="form-label">HR Phone Number</label>
            <input 
              type="text" 
              class="form-input" 
              placeholder="Enter phone number"
              [(ngModel)]="companyDetails.contact.hr_phone" 
              [readonly]="!isEditing"
              [class.editable]="isEditing"
              [class.input-error]="isEditing && isHrPhoneInvalid()"
            />
            <span class="error-text" *ngIf="isEditing && isHrPhoneInvalid()">
              Please enter a valid HR Phone Number.
            </span>
          </div>

        </div>
      </div>

      <!-- Floating or sticky bottom action bar during editing -->
      <div class="form-actions-bar animate-slide-up" *ngIf="isEditing">
        <div class="actions-container">
          <span class="unsaved-text">
            <span class="material-icons">warning</span>
            You have unsaved changes
          </span>
          <div class="actions-buttons">
            <button type="button" class="btn-cancel" (click)="cancelEditing()">
              Cancel
            </button>
            
            <!-- Save changes for Approved profile -->
            <button 
              type="button" 
              class="btn-save" 
              *ngIf="status === 'approved'" 
              (click)="saveProfileChanges()"
              [disabled]="isFormInvalid()"
            >
              Save Changes
            </button>

            <!-- Save and Resubmit for Rejected/Clarification profiles -->
            <button 
              type="button" 
              class="btn-resubmit" 
              *ngIf="status === 'rejected' || status === 'clarification'" 
              (click)="resubmitForReview()"
              [disabled]="isFormInvalid()"
            >
              <span class="material-icons">send</span>
              Resubmit for Review
            </button>
          </div>
        </div>
      </div>

    </div>

  </div>

  </ng-container>
</div>


